// provides common sort collator for natural sort

const naturalSort = new Intl.Collator(undefined, {
  numeric: true,
  sensitivity: 'base',
});

export default naturalSort.compare;
